// @flow
import React from "react";
import DropdownList from "root/components/DropdownList/DropdownList";
import t from "common/i18n";
import "./UploadPresetInput.scss";

export type Props = {
    options: string[],
    onChange: Function,
    value: ?string,
};

const UploadPresetInput = (props: Props) => (
	<DropdownList
		width={300}
		items={props.options || []}
		selectedItem={props.value}
		renderPlaceholder={() => <div className="">{t("advanced_options.upload_preset_placeholder")}</div>}
		renderInputValue={(val) => <div className="">{val}</div>}
		onChange={props.onChange}
		placement="top"
	/>
);

export default UploadPresetInput;
